import useSWR from "swr";
import fetcher from "./fetcher";

const defaultPolicies = [];

export default function usePoliciesAdmin() {
  const { data, isLoading, error, mutate } = useSWR(
    "/api/policy/admin/list",
    fetcher,
  );

  return {
    policies: data?.policies ?? defaultPolicies,
    isLoading,
    isError: Boolean(error),
    error,
    mutate,
  };
}
